function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* globals document window */

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { FlyoutWrapper, Frame, ScrollableContent } from './style';
import { whereToRender } from '../../utils/flyoutPositionHelper/flyoutPositionHelper';
import ElementMovementDetector from '../../utils/elementMovementDetector';
import positionsEquations from './positionEquations';
var Index = /*#__PURE__*/function (_React$Component) {
  _inherits(Index, _React$Component);
  var _super = _createSuper(Index);
  function Index(props) {
    var _this;
    _classCallCheck(this, Index);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "el", document.createElement('div'));
    _defineProperty(_assertThisInitialized(_this), "root", document.createElement('div'));
    _defineProperty(_assertThisInitialized(_this), "setPosition", function (parentPosition, childPosition, side) {
      var getPosition = positionsEquations[side];
      var _getPosition = getPosition(parentPosition, childPosition),
        x = _getPosition.x,
        y = _getPosition.y;
      _this.setState({
        calculatedSide: side,
        position: {
          x: x,
          y: y
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "calculatePosition", function () {
      var _this$props = _this.props,
        side = _this$props.side,
        fallbackRenderSide = _this$props.fallbackRenderSide,
        isStatic = _this$props.isStatic;
      if (_this.parentNode && _this.flyout) {
        var parentPosition = _this.parentNode.getBoundingClientRect();
        var childPosition = _this.flyout.getBoundingClientRect();
        // If isStatic is enabled, we do not want to know where to render because we already told where we want it (in the FREAKING SIDE), so we skip the function call.
        var renderSide = isStatic ? side : whereToRender(parentPosition, childPosition, side, fallbackRenderSide);
        _this.setPosition(parentPosition, childPosition, renderSide);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var onClose = _this.props.onClose;
      if (!_this.flyout.contains(e.target) && !_this.parentNode.contains(e.target)) {
        if (onClose) {
          onClose(e);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleRef", function (flyout) {
      _this.flyout = flyout;
    });
    _this.parentNode = document.getElementById(props.parent);
    _this.state = {
      calculatedSide: 'top',
      position: {
        x: 0,
        y: 0
      }
    };
    if (_this.parentNode) {
      _this.parentMovementDetector = new ElementMovementDetector(_this.parentNode, _this.calculatePosition);
      _this.parentMovementDetector.addMovementEventListener();
    }
    _this.root.setAttribute('id', "".concat(props.type, "-root"));
    document.body.appendChild(_this.root);
    return _this;
  }
  _createClass(Index, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.root.appendChild(this.el);
      this.calculatePosition();
      document.addEventListener('click', this.handleClick, true);
      window.addEventListener('resize', this.calculatePosition);
      window.addEventListener('scroll', this.calculatePosition);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeChild(this.root);
      document.removeEventListener('click', this.handleClick, true);
      window.removeEventListener('resize', this.calculatePosition);
      window.removeEventListener('scroll', this.calculatePosition);
      this.parentMovementDetector.removeMovementEventListener();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        animation = _this$props2.animation,
        border = _this$props2.border,
        type = _this$props2.type,
        onMouseLeave = _this$props2.onMouseLeave,
        className = _this$props2.className,
        isStatic = _this$props2.isStatic,
        maxHeight = _this$props2.maxHeight,
        maxWidth = _this$props2.maxWidth,
        side = _this$props2.side;
      var _this$state = this.state,
        position = _this$state.position,
        calculatedSide = _this$state.calculatedSide;
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(FlyoutWrapper, {
        type: type,
        onMouseLeave: onMouseLeave,
        ref: this.handleRef,
        animation: animation,
        className: className,
        side: side,
        calculatedSide: calculatedSide,
        position: position,
        isStatic: isStatic,
        parent: this.parentNode
      }, type === 'popup' ? /*#__PURE__*/React.createElement(ScrollableContent, {
        border: border,
        type: type,
        maxHeight: maxHeight,
        maxWidth: maxWidth
      }, /*#__PURE__*/React.createElement(Frame, null, children)) : /*#__PURE__*/React.createElement(Frame, null, children)), this.el);
    }
  }]);
  return Index;
}(React.Component);
Index.defaultProps = {
  children: null,
  animation: 'fadeIn',
  border: 'primary',
  onClose: null,
  onMouseLeave: null,
  className: '',
  fallbackRenderSide: 'top',
  isStatic: false,
  maxHeight: null,
  maxWidth: null
};
Index.propTypes = {
  type: PropTypes.oneOf(['tooltip', 'popup']).isRequired,
  children: PropTypes.node,
  // isStatic is the only document prop because is the most important one, what it does is block all the auto position detection stuff.
  // the popUp will show exactly where you told it to show, even if there is not enough space. DO AS I COMMAND PEASANT!
  isStatic: PropTypes.bool,
  animation: PropTypes.oneOf(['fadeIn']),
  parent: PropTypes.string.isRequired,
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string,
  side: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'topRight', 'bottomRight', 'topLeft', 'bottomLeft']).isRequired,
  border: PropTypes.oneOf(['primary', 'secondary']),
  onClose: PropTypes.func,
  onMouseLeave: PropTypes.func,
  className: PropTypes.string,
  fallbackRenderSide: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'topRight', 'bottomRight', 'topLeft', 'bottomLeft'])
};
Index.displayName = 'Flyout';
export default Index;